//'use strict';

module.exports = ['$scope', 'ngDroUAA', '$state', 'ngDroUtilsNotify', 'CanDoServices', 'ngDroAnimateIt', '$transitions',
    function ($scope, ngDroUAA, $state, ngDroUtilsNotify, CanDoServices, ngDroAnimateIt, $transitions) {
        /*
         * Config
         */

        // Informazioni per la parametrizzazione della direttiva button-add.
        $scope.infoAdd = {icon: 'fa-users', message: 'jdro_group.add'};

        $scope.item = null; // conterra il nuovo gruppo da inserire        
        $scope.query;       // query 

        /*
         * Init
         */

        // Ottengo i permessi per le operazioni Create         
        CanDoServices.canDo("GROUP").then(function (perms) {
            $scope.jdroPerms = perms;
        });

        // Caricamento dei Gruppi 
        loadGroups();

        // Setto un listener su transition start :
        //      se ho cambiato qualche campo e non ho salvato faccio uscire un modal di conferma.
        $scope.deregisterListener = $transitions.onStart({to: '*'}, catchStateTransition);
        ngDroUtilsNotify.setDeregisterListner( $scope.deregisterListener );

        /*
         * Methods
         */
        // Abilita/disabilita il pulsante salva
        $scope.isValid = function (item) {
            if (item && item.$new_title) {
                return item.$new_title.length > 2;
            }
        };

        // Validazione del campo title.
        $scope.invalidTitle = function (title) {
            if (title) {
                return (title.length > 0 && title.length < 3);
            }
        };

        $scope.remove = function (group) {
            delete $scope.item; // chiudo il pannello add
            if (!$scope.groups.some(isEditing)) {
                if (!group.id) {
                    loadGroups();
                    return;
                }
                var options = {
                    success: function () {
                        ngDroUAA.Group.delete(group.id)
                                .then(function () {
                                    loadGroups();
                                    ngDroUtilsNotify.deleteSuccess(group.title);
                                })
                                .catch(function (err) {
                                    ngDroUtilsNotify.deleteError(group.title,err);
                                });

                    },
                    itemTitle: group.title,
                    headTitle: 'jdro_group.confirm_delete'
                };
                ngDroUtilsNotify.confirmDelete(options);
            }
        };

        $scope.cancel = function (item) {
            item.$new_title = item.title;
            if (item.id) {
                item.title = item.$_backupItem.title;
                item.id = item.$_backupItem.id;
                delete item.$_isEditing;
                delete item.$_backupItem;
            } else {
                delete $scope.item;
            }
        };

        // Salvataggio dei un nuovo gruppo.
        $scope.save = function (group) {
            group.title = group.$new_title;
            delete $scope.item;

            if (!group.id) {
                ngDroUAA.Group.save(group)
                        .then(function (response) {
                            delete group.$_isEditing;
                            group.id = response.data.id;
                            $scope.groups.push(group);
                            ngDroUtilsNotify.insertSuccess(group.title);
                        })
                        .catch(function (err) {
                            ngDroUtilsNotify.insertError(group.title,err);
                            group.$new_title = group.title;
                        });
            } else {
                ngDroUAA.Group.update(group)
                        .then(function () {
                            delete group.$_isEditing;
                            //loadGroups();
                            ngDroUtilsNotify.updateSuccess(group.title);
                        })
                        .catch(function (err) {
                            ngDroUtilsNotify.updateError(group.title,err);
                            group.$new_title = group.title;
                        });
            }
        };

        // Click del bottone per aggiungere un nuovo ruolo.
        $scope.add = function () {
            if (!$scope.groups.some(isEditing)) {
                $scope.item = {
                    id: null,
                    $new_title: ""
                };
                ngDroAnimateIt('#newGroup', 'fadeInDown');
            }
        };

        // Questo metodo controlla se c'è un campo in editing, se si lancia il modal passando le 2 callback (save,cancel).
        // Il controllo unsavedChanges è stato fatto solo sull'Update (NB funzione hasPerms)
        function isEditing(group) {
            function onSave() {
                $scope.save(group, group.id);
                redirect();
            }

            function onCancel() {
                $scope.cancel(group);
                redirect();
            }

            function redirect() {
                if ($scope._gotoDestination) {    // se ho cliccato un cambio pagina
                    ngDroUtilsNotify.unregisterListner();
                    $state.go($scope._gotoDestination);
                    delete $scope._gotoDestination;
                }
            }

            function hasPerms() {
                return $scope.jdroPerms.UPDATE;
            }

            if (group.$_isEditing === true) {
                var options = {
                    form: true,
                    name: group.title,
                    success: onSave,
                    dismiss: onCancel,
                    perms: hasPerms
                };
                ngDroUtilsNotify.confirmUnsavedChanges(options);
                return true;
            } else {
                return false;
            }
        }

        $scope.edit = function (item) {
            delete $scope.item; // chiudo il pannello add
            preventTableEvents();
            if (!$scope.groups.some(isEditing)) {
                var backupItem = {};
                angular.copy(item, backupItem);
                item.$_backupItem = backupItem;
                item.$_isEditing = true;
            }
        };

        // Uso $new_value al posto di title, sennò mentre digito, viene ordinato nella tabella
        $scope.copy = function (item) {
            item.$new_title = item.title;
        };

        function loadGroups() {
            ngDroUAA.Group.findAll().then(function (response) {
                $scope.groups = response.data;
            }).catch(function (err) {
                ngDroUtilsNotify.unregisterListner();
                ngDroUtilsNotify.error(null, 'jdro_group.error.find_all', null, err);
            });
        }

        function preventTableEvents() {
            $scope.query = '';
        }

        // per $transitions, cattura gestisce unsaved changes
        function catchStateTransition(transition) {
            if ($scope.groups) {
                if (!$scope.groups.some(isEditing)) {
                    ngDroUtilsNotify.unregisterListner();
                    $state.go(transition.to().name);
                } else {
                    $scope._gotoDestination = transition.to().name; //mi salvo nello scope la destinazione, mi servirà nelle callback
                    return false; // equivale al vecchio event.preventDefault();
                }
            }
        }
    }];


//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/components/group/groupList/groupListCtrl.js
// module id = 418
// module chunks = 0